// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const organizationSchema = z.object({
  "id": z.string().uuid(),
  "tenant_id": z.string().uuid(),
  "name": z.string(),
  "slug": z.string(),
  "display_name": z.string().optional(),
  "logo_uri": z.string().optional(),
  "primary_color": z.string().optional(),
  "contact_name": z.string().optional(),
  "contact_email": z.string().optional(),
  "sign_in_provider": z.string().optional(),
  "status": z.enum(["active", "suspended", "deactivated"]),
  "population_archetype": z.enum(["workforce_iam", "standalone_iam", "consumer_ciam"]),
  "webauthn": z.object({
    "attestation": z.string().optional(),
    "authenticator_attachment": z.string().optional(),
    "backup_eligibility": z.string().optional(),
    "resident_key": z.string().optional(),
    "user_verification": z.string().optional()
  }),
  "max_users": z.number().int().min(0).optional(),
  "live_user_count": z.number().int().min(0).optional(),
  "waiting_requests": z.number().int().min(0).optional(),
  "created_at": z.string().datetime({ offset: true }),
  "updated_at": z.string().datetime({ offset: true }),
  "provisioning_last_push_at": z.string().datetime({ offset: true }).optional(),
  "provisioning_last_failure_at": z.string().datetime({ offset: true }).optional()
});

export const organizationsListResponseSchema = z.object({
  "items": z.array(organizationSchema),
  "next_cursor": z.string().uuid().optional()
});
